import LayoutComp from "./components/LayoutComp";
import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  // The back to top button is hidden initially
  const [showGoTopButton, setGoTopButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => setGoTopButton(window.pageYOffset > 500);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
      window.scrollTo({
        top:0,
        behavior:"smooth"
      });
  };

  return (
    <HelmetProvider>
    <BrowserRouter>
      <div className="App">
        <LayoutComp />

        {showGoTopButton && (
            <button onClick={scrollToTop} className="back-to-top" title="&#8679; Go To Top">
              &#8679;
            </button>
        )}
      </div>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
